"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _BottomFrameImage = require("./BottomFrameImage");
Object.keys(_BottomFrameImage).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _BottomFrameImage[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _BottomFrameImage[key];
    }
  });
});
